<template>
  <v-card
    elevation="0"
    class="card-box-shadow pa-0 w-100 h-100"
    style="border-radius: 10px; overflow-y: auto"
  >
    <v-card-title class="px-3 py-2 d-flex justify-space-between">
      <h5 class="text-caption mr-1 font-weight-bold">Vehicle Details</h5>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-subtitle>
      <v-row no-gutters>
        <v-col cols="6" class="pb-1" v-if="detailsObj.vehicle_number">
          <TripTooltipWithIcon
            icon="mdi-truck"
            :text="detailsObj.vehicle_number"
            label="vehicle number"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="detailsObj.tonnage_capacity">
          <TripTooltipWithIcon
            icon="mdi-weight"
            :text="detailsObj.tonnage_capacity"
            label="vehicle tonnage capacity"
          />
        </v-col>
        <v-col cols="6" class="pb-1" v-if="detailsObj.cbm_capacity">
          <TripTooltipWithIcon
            icon="mdi-cube"
            :text="detailsObj.cbm_capacity"
            label="vehicle cbm capacity"
          />
        </v-col>
      </v-row>
    </v-card-subtitle>
  </v-card>
</template>

<script>
import TripTooltipWithIcon from "@/components/ModuleBasedComponents/Trip/TripTooltipWithIcon.vue";
export default {
  components: {
    TripTooltipWithIcon,
  },
  props: {
    detailsObj: {
      required: true,
    },
  },
};
</script>